<script>
import Modal from "./Modal";

export default {
  props: ["trigger"],

  mixins: [Modal],

  data() {
    return {
      data: {},
    };
  },

  mounted() {
    const vm = this;

    this.$on("modal-opened", () => {});

    this.$root.$on(this.trigger, (data) => {
      if (typeof data === "object" && data !== null) {
        Object.entries(data).forEach((entry) => {
          const [key, value] = entry;
          this[key] = value;
        });
      }

      vm.open();
    });
  },
};
</script>
